<template>
  <div class="">
    <static-tabs-wallet active="groups"> </static-tabs-wallet>
    <registry-groups> </registry-groups>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import RegistryGroups from "@/components/wallet/registry-groups/index.vue";
import StaticTabsWallet from "@/components/wallet/static-tabs.vue";
export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  props: {},
  components: {
    RegistryGroups,
    StaticTabsWallet,
  },
  created() {
    this.notifyQueue({
      text: "Portafoglio",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Gruppi",
      path: "registry_groups.index",
      level: 2,
    });
  },
};
</script>
